import { render, staticRenderFns } from "./CpuCard.vue?vue&type=template&id=3b0d96a9&scoped=true&"
import script from "./CpuCard.vue?vue&type=script&lang=ts&"
export * from "./CpuCard.vue?vue&type=script&lang=ts&"
import style0 from "./CpuCard.vue?vue&type=style&index=0&id=3b0d96a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d96a9",
  null
  
)

export default component.exports